export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/media.worker.f1cb2920.worker.js");
}
